import { Breadcrumb, Pagination } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { useProducts } from '@api/home/products/useProducts'
import { SkeletonImg, Switch } from '@ui-pc'
import { ViewMore } from '@ui-pc/Widget-yopt'

import flashIcon from '../../assets/imgs/flash-icon1.png'
import listEmpty from '../../assets/imgs/listEmpty.png'
import proTitleBg from '../../assets/imgs/proTitleBg.png'
import ProductList from '../../components/ProductList'
import FilterSort from './components/FilterSort'
import SecondCategory from './components/SecondCategory'
import SortBy from './components/SortBy'
import styles from './index.module.scss'

interface IProductsProps {
  isFlash?
  isSearch?: boolean
  isCategory?: boolean
  isCustompro?: boolean
  params?: any | undefined
  initLoading?: boolean
  showSkeletonList?: boolean
  pageType?: number
  onFetch?: Function
  onChangePage?: Function | undefined
  isCustomTitle?
  pageSize?
  showViewMore?
}

const Products: React.FunctionComponent<IProductsProps> = (props) => {
  const {
    isSearch,
    isCategory,
    isCustompro,
    params,
    initLoading,
    showSkeletonList,
    showViewMore,
    isFlash
  } = props

  const {
    size,
    navBread,
    changePages,
    breadcrumbItems,
    pageName,
    productList,
    isFlashDeal,
    categoriesImg,
    categoryName,
    categoriesDescription,
    filterData,
    pageSize,
    productCount,
    changeAttrSelect,
    productsData,
    display,
    removeActive,
    maxPrice,
    removeAll,
    handleChangeSort,
    page,
    changePage,
    banners
  } = useProducts(false, props)

  const sortLabelRef = React.useRef('')

  const fdBanner = banners?.flashDealBanner || {}
  const fdBannerIamge = Array.isArray(fdBanner?.bannersImage)
    ? fdBanner?.bannersImage[0]
    : []

  return (
    <>
      <div className={`${styles['products']} products-wrap`}>
        <div className='global-section-inner'>
          {/* 面包屑 */}
          <Switch either={(isCategory || isSearch) && navBread?.length}>
            <Breadcrumb items={breadcrumbItems} />
          </Switch>
        </div>
        <div className='second-category-wrap'>
          {/* 热销、新品、闪购 标题*/}
          <Switch either={pageName && productList?.length}>
            <div className={styles['products-other-title-bg']}>
              {categoriesImg ? (
                <img src={categoriesImg} alt={pageName} />
              ) : (
                <>
                  <img
                    src={isFlashDeal ? fdBannerIamge?.image : proTitleBg}
                    alt={pageName}
                  />
                  {/* <div className={styles['other-title']}>
                    {isFlashDeal ? <img src={flashIcon} alt={pageName} /> : ''}
                    {pageName}
                  </div> */}
                  {!isFlashDeal && (
                    <div className={styles['other-title']}>{pageName}</div>
                  )}
                </>
              )}
            </div>
          </Switch>

          {/* 自定义产品集合页 */}
          <Switch either={isCustompro}>
            <Switch either={initLoading}>
              <div className={`${styles['custom-pro-banner']}`}>
                <SkeletonImg />
              </div>
              {categoriesImg ? (
                <div className={`${styles['custom-pro-banner']}`}>
                  <img src={categoriesImg} />
                </div>
              ) : null}
            </Switch>
          </Switch>

          {/* 类目页 */}
          <Switch either={isCategory}>
            <>
              {categoriesImg ? (
                <div className={styles['products-head']}>
                  <img src={categoriesImg} alt='' />
                  <div className={styles['products-head-tit']}>
                    <h3>{categoryName}</h3>
                    <p>{categoriesDescription}</p>
                  </div>
                </div>
              ) : (
                <div className={`${styles['products-title']} products-title`}>
                  {categoryName}
                </div>
              )}

              {/* {productsData?.data.subCategoriesList?.length ? (
                <SecondCategory list={productsData?.data.subCategoriesList} />
              ) : (
                ''
              )} */}
            </>
          </Switch>
        </div>
        <div
          className={`global-section-inner products-for-feed ${styles['products-main']}`}
        >
          {/* 类目页 */}
          <Switch either={isCategory}>
            <>
              {productsData?.data.subCategoriesList?.length ? (
                <SecondCategory list={productsData?.data.subCategoriesList} />
              ) : null}
            </>
          </Switch>

          {/* 搜索页标题 */}
          <Switch either={isSearch}>
            <div className={styles['products-title']}>
              Showing results for “
              {params.keywords ? decodeURIComponent(params.keywords) : ''}”
            </div>
          </Switch>

          {/* 左侧筛选， 右侧产品 */}
          <div className={`${styles['products-inner']} products-inner`}>
            <Switch either={isSearch || isCategory || isCustompro || isFlash}>
              <div className={styles['section-filter']}>
                <div className={styles['section-filter-attr']}>
                  <Switch
                    either={
                      filterData?.filterList?.length &&
                      (isSearch ||
                        isCategory ||
                        isCustompro ||
                        isFlash ||
                        params.filterValueIds)
                    }
                  >
                    <>
                      <FilterSort
                        initData={productsData?.data}
                        data={filterData.filterList}
                        handleChange={changeAttrSelect}
                        filterForm={params}
                      />
                      {/* 选中属性 */}
                      {display?.length || params.minPrice || params.maxPrice ? (
                        <div className={styles['active-filter']}>
                          {display.length
                            ? display.map((ele: any) => {
                                return (
                                  <div
                                    key={ele.productsOptionsValuesId}
                                    className={styles['active-filter-item']}
                                    onClick={() =>
                                      removeActive(
                                        ele.productsOptionsValuesId ||
                                          String(ele.id),
                                        ele.productsOptionsId == 'c' ||
                                          ele.productsOptionsId == 's'
                                          ? 'filterCat'
                                          : 'filterValueIds',
                                        false
                                      )
                                    }
                                  >
                                    {ele.productsOptionsId === 'p'
                                      ? `Price ${ele.productsOptionsValuesName}`
                                      : ele.productsOptionsValuesName ||
                                        ele.categoriesName}

                                    <i className='iconfont icon-close'></i>
                                  </div>
                                )
                              })
                            : null}
                          {params.minPrice || params.maxPrice ? (
                            <div
                              className={styles['active-filter-item']}
                              onClick={() => removeActive('price')}
                            >
                              {`Price ${
                                params.minPrice ? params.minPrice : '0'
                              }-${
                                params.maxPrice ? params.maxPrice : maxPrice
                              }`}
                              <i className='iconfont icon-close'></i>
                            </div>
                          ) : null}
                          <div
                            className={styles['clear-all']}
                            onClick={() => removeAll()}
                          >
                            Clear All
                          </div>
                        </div>
                      ) : null}
                    </>
                  </Switch>
                </div>
                <>
                  <Switch either={filterData.orderSelect?.length}>
                    <SortBy
                      filterForm={params}
                      filterData={filterData}
                      handleChangeSort={handleChangeSort}
                      label={sortLabelRef}
                    />
                  </Switch>
                </>
              </div>
            </Switch>

            <div className={styles['section-list']}>
              {productList?.length ? (
                <>
                  <ProductList
                    column={4}
                    list={productList}
                    noSkus={isFlashDeal}
                    showAddCart={false}
                    showSoldOut={true}
                    showStartInFd={isFlashDeal}
                    showSkeletonList={showSkeletonList}
                    name={`${sortLabelRef.current}`}
                  />
                  <div className={styles['page-bottom']}>
                    <Switch either={showViewMore}>
                      <Switch either={size < productCount}>
                        <ViewMore onClick={changePages} />
                      </Switch>
                      <Pagination
                        current={Number(page)}
                        hideOnSinglePage={true}
                        pageSize={pageSize || params?.pageSize}
                        showSizeChanger={false}
                        total={productCount}
                        onChange={changePage}
                      />
                    </Switch>
                  </div>
                </>
              ) : null}
              {/* 空数据展示  */}
              {!initLoading && !productList?.length ? (
                <div className={styles['products-list-empty']}>
                  <img src={listEmpty} />
                  {isSearch ? (
                    <p className={styles['empty-tips']}>
                      There is no results for "
                      {params.keywords
                        ? decodeURIComponent(params.keywords)
                        : ''}
                      "
                    </p>
                  ) : (
                    <p className={styles['empty-tips']}>Your List is Empty</p>
                  )}
                  <Link to='/' className={styles['empty-search-link']}>
                    Return Home
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

// const customCb = (location) => {
//   let title: string | null = ''
//   if (location.pathname.indexOf('/search') > -1) {
//     const params = getSearchParams(location.search, ['keywords', 'q'] as const)
//     title = params.keywords || params.q || 'search'
//   } else if (
//     /^(\/flashDeal|\/hot|\/new|\/new-arrivals)$/.test(location.pathname)
//   ) {
//     title = location.pathname.split('/')?.[1]
//   } else if (location.pathname.indexOf('/custompro') > -1) {
//     title = 'custompro'
//   }
//   return title
// }

export default Products
//export default MetaHoc(Products, customCb)
